import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* ---------- LEFT: LOGO & DESCRIPTION ---------- */}
        <div className="footer-section footer-about">
          <img
            src="/images/logo/logo.png"
            alt="JB Corporation Ahmedabad Gujarat company logo"
            title="JB Corporation Logo"
            className="footer-logo"
          />
          <p>
            JB Corporation Ahmedabad Gujarat is a trusted name in industrial manufacturing,
            delivering innovative, high-quality Linear Motion Products with precision and
            reliability. Leading supplier of Rack & Pinion, Ball Screws, and LM Guides in Kathwada.
          </p>
        </div>

        {/* ---------- CENTER: QUICK LINKS ---------- */}
        <div className="footer-section links">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="/"><i className="fa-solid fa-forward"></i>Home</a></li>
            <li><a href="/about"><i className="fa-solid fa-forward"></i>About</a></li>
            <li><a href="/products"><i className="fa-solid fa-forward"></i>Products</a></li>
            <li><a href="/gallery"><i className="fa-solid fa-forward"></i>Gallery</a></li>
            <li><a href="/contact"><i className="fa-solid fa-forward"></i>Contact</a></li>
          </ul>
        </div>

        {/* ---------- RIGHT: CONTACT INFO ---------- */}
        <div className="footer-section footer-contact">
          <h3>Contact Us</h3>
          <p><a href="tel:+919265581679"><i className="fa-solid fa-phone"></i> +91 92655 81679</a></p>
          <p><a href="tel:+918160854963"><i className="fa-solid fa-phone"></i> +91 81608 54963</a></p>
          <p>
            <a
              href="mailto:jbcorporation2023@gmail.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-solid fa-envelope"></i> jbcorporation2023@gmail.com
            </a>
          </p>
          <p>
            <a
              href="https://maps.app.goo.gl/qmCBM58s4wLLsih7A"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-solid fa-location-dot"></i> Kathwada, Ahmedabad
            </a>
          </p>

          <div className="footer-social">
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-linkedin-in"></i>
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-instagram"></i>
            </a>
            <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer">
              <i className="fa-brands fa-whatsapp"></i>
            </a>
            <a href="tel:+919876543210">
              <i className="fa-solid fa-phone"></i>
            </a>
          </div>
        </div>

        {/* ---------- PHOTO SHOWCASE ---------- */}
        <div className="footer-section showcase">
          <h3>Photo Showcase</h3>
          <div className="showcase-grid">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <img
                key={i}
                src={`/images/products/jb${i}.jpeg`}
                alt={`JB Corporation product sample ${i}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* ---------- BOTTOM COPYRIGHT ---------- */}
      <div className="footer-bottom">
        <p>
          © 2025 <strong className="apnawebx">JB Corporation</strong>. All Rights Reserved.
        </p>

        <p>
          Developed By{' '}
          <a
            href="https://www.apnawebx.com"
            target="_blank"
            rel="noopener noreferrer"
            className="apnawebx"
          >
            <strong>APNAWEBX</strong>
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
